import type { RightDrawerTabItem } from './types';

import { RightDrawerTab } from './types';

export const ON_LOAD_TEMPLATE_DEBOUNCE = 150;

export const RIGHT_DRAWER_FILTER_HEIGHT = 50;

export const RIGHT_DRAWER_WIDTH = 384;

export const COMPACT_HEIGHTS = {
  collapseSectionHeaderHeight: 120,
  collapseSectionHeight: 170,
  minSectionHeight: 40,
} as const;

export const DEFAULT_HEIGHTS = {
  collapseSectionHeaderHeight: 170,
  collapseSectionHeight: 228,
  minSectionHeight: 80,
} as const;

export const PRIORS_SUMMARY_COMPACT_HEIGHTS = {
  collapseSectionHeaderHeight: 170,
  collapseSectionHeight: 228,
  minSectionHeight: 150,
  defaultSectionHeight: 175,
} as const;

export const PRIORS_SUMMARY_DEFAULT_HEIGHTS = {
  collapseSectionHeaderHeight: 170,
  collapseSectionHeight: 228,
  minSectionHeight: 200,
  defaultSectionHeight: 225,
} as const;

export const COMPACT_MINIMUM_PICKLISTS_HEIGHT = 150;

export const DEFAULT_MINIMUM_PICKLISTS_HEIGHT = 200;

export const HEADER_BASE_LENGTH = 2;

export const DEFAULT_RIGHT_DRAWER_TABS: Array<RightDrawerTabItem> = [
  {
    tab: RightDrawerTab.Template,
    label: 'Templates',
  },
  {
    tab: RightDrawerTab.Macro,
    label: 'Macros',
  },
];

export const ICON_COLOR = 'rgba(236, 236, 236, 0.56)';

export const DOUBLE_CLICK_TIMEOUT = 250;
